import styled from "styled-components";

const SVG = styled.svg`
    .mask {
        mask-type: luminance;
    }
`;

function EFManagementIcon({ color }) {
    return (
        <SVG width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_202_10322" className={"mask"} maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
                <path d="M0.330078 0.75H16.3301V16.75H0.330078V0.75Z" fill="white" />
            </mask>
            <g mask="url(#mask0_202_10322)">
                <path d="M1.61188 1.37598V3.83432M1.61188 3.83432H4.07023M1.61188 3.83432C2.46201 2.36473 4.05091 1.37598 5.87079 1.37598H10.7874C13.5029 1.37598 15.7041 3.57723 15.7041 6.29263V11.2093C15.7041 13.9247 13.5029 16.126 10.7874 16.126H5.87079C3.15538 16.126 0.954102 13.9247 0.954102 11.2093V8.75098M10.7874 11.2093L8.3291 8.75098V5.06348"
                    stroke={color || "#505050"} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </SVG>
    )
}

export default EFManagementIcon;